// extracted by mini-css-extract-plugin
export var desktop = "styles-module--desktop--9402b";
export var footer = "styles-module--footer--dc9ca";
export var mobile = "styles-module--mobile--156dc";